<template>
  <div>
    <transition name="el-fade-in-linear">
      <div class="main_wrap" v-show="shown.mainshow">
        <div class="head_wrap">
          <div class="head_bar">
            <div class="bar_title"><span>iFi Audio</span></div>
            <div class="bar_items">
              <div v-if="
                this.$route.path == '/console/international_order' ||
                this.$route.path == '/console/domestic_order'
              ">
                <el-button type="info" icon="el-icon-s-operation" circle size="mini" @click="hiddenMenu"
                  v-if="false"></el-button>
              </div>
              <div class="language_wrap">
                <el-dropdown placement="bottom" :show-timeout="100" @command="setLanguage">
                  <el-button type="primary" size="mini" circle icon="el-icon-s-tools">
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="cn">中文</el-dropdown-item>
                    <el-dropdown-item command="en">English</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div>
                <el-tooltip class="item" effect="dark" :content="$t('App.page.console.tip_refresh')" placement="bottom">
                  <el-button type="success" icon="el-icon-download" circle size="mini"
                    @click="reloadDocument"></el-button>
                </el-tooltip>
              </div>
              <div>
                <el-popover placement="bottom" trigger="hover" width="180"
                  :content="$t('App.notify.span_no_notification')">
                  <i class="el-icon-message-solid" style="font-size: 1.1rem; color: #ffffff" slot="reference"></i>
                </el-popover>
              </div>
              <div>
                <el-dropdown placement="bottom" :show-timeout="100">
                  <el-avatar :size="30">{{ pageData.username }}</el-avatar>
                  <el-dropdown-menu slot="dropdown">
                    <div class="avatar_dropdown_items_content">
                      <el-dropdown-item>
                        <span @click="openTabOnAva('/console/mysetting')">{{ $t('App.page.console.router_settings') }}
                        </span>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <router-link to="/login" @click.native="custLogout">{{
                          $t('App.page.console.router_logout')
                          }}</router-link>
                      </el-dropdown-item>
                    </div>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div class="body_wrap">
          <div class="menu_main_wrap" id="menu_main_wrap">
            <el-menu router :default-active="pageData.mainMenu.activeIndex"
              :default-openeds="pageData.mainMenu.activeSub" class="mainmenu_content" ref="mainmenu_content"
              background-color="#323233" text-color="#fff" active-text-color="#ffd04b" @select="openTabOnMenu">
              <!-- <el-submenu
                index="8"
                v-if="
                  pageData.Userinfo.region !== 2 &&
                  pageData.Userinfo.region !== 4 &&
                  pageData.Userinfo.region !== 5
                "
              >
                <template slot="title">
                  <i class="el-icon-s-tools"></i>
                  <span>{{ $t('App.page.console.menuitem_settings') }}</span>
                </template>
<el-menu-item index="/console/general" :disabled="true">{{
  $t('App.page.console.childmenuitem_general')
  }}</el-menu-item>
<el-menu-item index="/console/permission" :disabled="true">{{
  $t('App.page.console.childmenuitem_permissions')
  }}</el-menu-item>
</el-submenu> -->

              <el-submenu index="1" v-if="
                pageData.Userinfo.region !== 2 &&
                pageData.Userinfo.region !== 5 &&
                pageData.Userinfo.region !== 4
              ">
                <template slot="title">
                  <i class="el-icon-user-solid"></i>
                  <span>{{ $t('App.page.console.menuitem_user') }}</span>
                </template>
                <el-menu-item index="/console/sales_user" :disabled="true">{{
                  $t('App.page.console.childmenuitem_controluser')
                  }}</el-menu-item>
                <el-menu-item index="/console/international_customer" :disabled="pageData.Userinfo.region !== 0 &&
                  pageData.Userinfo.region !== 3
                  ">{{
                    $t('App.page.console.childmenuitem_customer')
                  }}</el-menu-item>
                <el-menu-item index="/console/domestic_customer" :disabled="pageData.Userinfo.region !== 1 &&
                  pageData.Userinfo.region !== 3
                  ">{{
                    $t('App.page.console.childmenuitem_domesticcustomer')
                  }}</el-menu-item>
              </el-submenu>

              <el-submenu index="2" v-if="pageData.Userinfo.region !== 2">
                <template slot="title">
                  <i class="el-icon-s-order"></i>
                  <span>{{ $t('App.page.console.menuitem_order') }}</span>
                </template>
                <el-menu-item index="/console/international_order" :disabled="pageData.Userinfo.region !== 0 &&
                  pageData.Userinfo.region !== 3 &&
                  pageData.Userinfo.region !== 5
                  ">{{
                    $t('App.page.console.childmenuitem_orderlists')
                  }}</el-menu-item>
                <el-menu-item index="/console/domestic_order" :disabled="pageData.Userinfo.region !== 1 &&
                  pageData.Userinfo.region !== 3
                  ">{{
                    $t('App.page.console.childmenuitem_domesticorder')
                  }}</el-menu-item>
                <el-menu-item index="/console/quickordering" :disabled="pageData.Userinfo.region !== 0 &&
                  pageData.Userinfo.region !== 3 &&
                  pageData.Userinfo.region !== 5
                  ">
                  {{ $t('App.page.console.childmenuitem_quickorder') }}
                </el-menu-item>
                <el-menu-item index="/console/globalemail" :disabled="pageData.Userinfo.region !== 0 &&
                  pageData.Userinfo.region !== 3
                  ">{{
                    $t('App.page.console.childmenuitem_globalemail')
                  }}</el-menu-item>
              </el-submenu>

              <el-submenu index="11">
                <template slot="title">
                  <i class="el-icon-s-marketing"></i>
                  <span>{{ $t('App.page.console.dataplatform') }}</span>
                </template>
                <el-menu-item index="/console/shopifyorder">{{
                  'Shopify ' + $t('App.page.console.shopify')
                  }}</el-menu-item>
              </el-submenu>

              <!-- <el-submenu index="10" v-if="pageData.Userinfo.region !== 2">
                <template slot="title">
                  <i class="el-icon-s-order"></i>
                  <span>{{ $t('App.page.console.menuitem_webstore') }}</span>
                </template>

                <el-menu-item index="/console/w-order">{{
                  $t('App.page.console.childmenuitem_order')
                }}</el-menu-item>

                <el-menu-item index="/console/shopify">{{
                  $t('App.page.console.childmenuitem_order1')
                }}</el-menu-item>
              </el-submenu> -->

              <el-submenu index="3" v-if="
                pageData.Userinfo.region !== 2 &&
                pageData.Userinfo.region !== 5 &&
                pageData.Userinfo.region !== 4
              ">
                <template slot="title">
                  <i class="el-icon-cpu"></i>
                  <span>{{ $t('App.page.console.menuitem_product') }}</span>
                </template>
                <el-menu-item index="/console/synproducts">{{
                  $t('App.page.console.childmenuitem_synproducts')
                  }}</el-menu-item>
                <el-menu-item index="/console/pricingrules" :disabled="pageData.Userinfo.region !== 0 &&
                  pageData.Userinfo.region !== 3
                  ">{{
                    $t('App.page.console.childmenuitem_pricingrules')
                  }}</el-menu-item>
                <el-menu-item index="/console/discountrules" :disabled="pageData.Userinfo.region !== 0 &&
                  pageData.Userinfo.region !== 3
                  ">{{
                    $t('App.page.console.childmenuitem_discountrules')
                  }}</el-menu-item>
                <el-menu-item index="/console/pricesystem" :disabled="pageData.Userinfo.region !== 0 &&
                  pageData.Userinfo.region !== 3
                  ">{{
                    $t('App.page.console.childmenuitem_pricesystem')
                  }}</el-menu-item>
              </el-submenu>

              <!-- <el-submenu
                index="7"
                v-if="
                  pageData.Userinfo.region !== 1 &&
                  pageData.Userinfo.region !== 2
                "
              >
                <template slot="title">
                  <i class="el-icon-s-home"></i>
                  <span>{{ $t('App.page.console.menuitem_3pl') }}</span>
                </template>
                <el-menu-item index="/console/standardorder" :disabled="true">{{
                  $t('App.page.console.childmenuitem_g_standardorder')
                }}</el-menu-item>
                <el-menu-item
                  index="/console/webstoreorder"
                  :disabled="false"
                  >{{
                    $t('App.page.console.childmenuitem_g_platformorder')
                  }}</el-menu-item
                >
              </el-submenu> -->

              <el-submenu index="4" v-if="
                pageData.Userinfo.region !== 2 &&
                pageData.Userinfo.region !== 4 &&
                pageData.Userinfo.region !== 5
              ">
                <template slot="title">
                  <i class="el-icon-folder-opened"></i>
                  <span>{{ $t('App.page.console.menuitem_properties') }}</span>
                </template>
                <el-menu-item index="/console/country">{{
                  $t('App.page.console.childmenuitem_country')
                  }}</el-menu-item>
                <el-menu-item index="/console/currency">{{
                  $t('App.page.console.childmenuitem_currency')
                  }}</el-menu-item>
                <el-menu-item index="/console/exchangerate" :disabled="true">{{
                  $t('App.page.console.childmenuitem_exchangerate')
                  }}</el-menu-item>
                <el-menu-item index="/console/unit" :disabled="true">{{
                  $t('App.page.console.childmenuitem_unit')
                  }}</el-menu-item>
                <el-menu-item index="/console/payment">{{
                  $t('App.page.console.childmenuitem_paymentterms')
                  }}</el-menu-item>
                <el-menu-item index="/console/orderstatus">{{
                  $t('App.page.console.childmenuitem_ordertatus')
                  }}</el-menu-item>
                <el-menu-item index="/console/brand">{{
                  $t('App.page.console.childmenuitem_brand')
                  }}</el-menu-item>
              </el-submenu>

              <el-submenu index="5" v-if="
                pageData.Userinfo.region !== 1 &&
                pageData.Userinfo.region !== 4 &&
                pageData.Userinfo.region !== 5
              ">
                <template slot="title">
                  <i class="el-icon-chat-dot-round"></i>
                  <span>{{ $t('App.page.console.menuitem_feedback') }}</span>
                </template>
                <el-menu-item index="/console/satisfacationsurvey" :disabled="pageData.Userinfo.region === 1">{{
                  $t('App.page.console.childmenuitem_satisfacation')
                }}</el-menu-item>
              </el-submenu>

              <el-submenu index="9" v-if="pageData.Userinfo.region !== 2">
                <template slot="title">
                  <i class="el-icon-refresh-right"></i>
                  <span>{{ $t('App.page.console.menuitem_aftersales') }}</span>
                </template>
                <el-menu-item index="/console/serialnumbertool">{{
                  $t('App.page.console.childmenuitem_sn')
                  }}</el-menu-item>
              </el-submenu>

              <el-submenu index="6" v-if="
                pageData.Userinfo.region !== 4 &&
                pageData.Userinfo.region !== 5
              ">
                <template slot="title">
                  <i class="el-icon-s-data"></i>
                  <span>{{ $t('App.page.console.menuitem_data') }}</span>
                </template>
                <el-menu-item index="/console/statistics" :disabled="true">{{
                  $t('App.page.console.childmenuitem_statistics')
                  }}</el-menu-item>
                <el-menu-item index="/console/analysis">{{
                  $t('App.page.console.childmenuitem_analysis')
                  }}</el-menu-item>
                <el-menu-item index="/console/bigdata" :disabled="true">{{
                  $t('App.page.console.childmenuitem_bigdata')
                  }}</el-menu-item>
              </el-submenu>

            </el-menu>
          </div>
          <div class="contents">
            <div class="tabls_content" v-if="tabs.editableTabs.length != 0">
              <el-tabs type="card" v-model="tabs.activeTab" closable @tab-remove="removeTab" @tab-click="clickTab">
                <el-tab-pane v-for="(item, index) in tabs.editableTabs" :key="item.name" :name="item.name"
                  :index="index">
                  <span slot="label">
                    <!-- <i class="el-icon-s-opportunity"></i> -->
                    {{ item.title }}</span>
                  <div class="childviews_content">
                    <keep-alive><router-view /></keep-alive>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="no_router_content" v-else>
              <div class="top_explain">
                {{ $t('App.page.console.topexplain') }}
              </div>
            </div>
          </div>
        </div>
        <div class="foot_wrap"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from 'vue'
import * as verifyjs from '@/assets/js/verify'
export default {
  data() {
    return {
      shown: {
        mainshow: false,
      },
      pageData: {
        username: '',
        salesuser: {},
        Userinfo: {},
        mainMenu: {
          activeIndex: '',
          activeSub: ['1', '2', '3', '11'],
        },
        smileSrc: require('@/assets/images/smile_1.png'),
      },
      tabs: {
        activeTab: '',
        editableTabs: [],
        tabIndex: 0,
      },
      formData: {},
    }
  },
  created() {
    this.$npg.start()
    this.$npg.inc()
  },
  mounted() {
    this.prepareForMounted()
  },
  methods: {
    prepareForMounted() {
      this.$npg.done()
      this.pageData.username = sessionStorage.getItem('username')
      this.pageData.salesuser.username = this.pageData.username
      this.pageData.Userinfo = JSON.parse(
        sessionStorage.getItem(this.pageData.username)
      )
      if (verifyjs.isMountedManage(this)) {
        document.title = this.$t('App.title.console')
        this.getCountry()
        this.getCurrency()
        this.getWay()
        this.getFlags()
        setTimeout(() => {
          this.shown.mainshow = true
        }, 1)
      } else {
        this.$router.push({ name: 'Login' })
      }
    },
    hiddenMenu() {
      this.$nextTick(() => {
        let menuObj = document.getElementById('menu_main_wrap')
        if (menuObj.style.width != '120rem' && menuObj.style.width.length > 0) {
          menuObj.style.width = '120rem'
        } else if (menuObj.style.width == '0') {
          menuObj.style.width = '0'
        } else {
          menuObj.style.width = '0'
        }
      })
    },
    reloadDocument() {
      this.$notify.success({
        title: this.$t('App.notify.title_nofity'),
        message: this.$t('App.notify.ntf_uptodate'),
      })
    },
    setLanguage(command) {
      this.$i18n.locale = command
      sessionStorage.setItem('lang', this.$i18n.locale)
      this.reloadDocument()
    },
    getWay() {
      let ntf = sessionStorage.getItem('wayntf')
      if (ntf == null) {
        sessionStorage.setItem('wayntf', 1)
        if (this.pageData.Userinfo.way == 1) {
          this.$notify.success({
            title: this.$t('App.notify.title_nofity'),
            message: this.$t('App.notify.loginviadingtalk'),
            // duration: 0
          })
        } else if (this.pageData.Userinfo.way == 0) {
          this.$notify.warning({
            title: this.$t('App.notify.title_nofity'),
            message: this.$t('App.notify.loginviapass'),
            // duration: 0
          })
        }
      }
    },
    getFlags() {
      let list = []
      let arr = ['NF_OV']
      for (let i in arr) {
        let obj = {}
        obj.name = arr[i]
        list.push(obj)
      }

      this.$axios({
        method: 'post',
        // url: Vue.prototype.api + '6004/api/local/queryFlag',
        url: Vue.prototype.api + 'api/local/queryFlag',
        data: list,
      })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.code == '200' || response.data.code == '210') {
              if (response.data.data[0].isdel == 1) {
                this.$notify.warning({
                  title: this.$t('App.notify.title_warning'),
                  message: this.$t('App.notify.lotsoforder'),
                  duration: 0,
                  position: 'top-left',
                })
              }

              return
            } else if (response.data.code == '210') {
              this.$notify.error({
                title: this.$t('App.notify.title_server'),
                message: this.$t('App.notify.content_entitiesept'),
              })
              return
            } else {
              this.$notify.error({
                title: this.$t('App.notify.title_server'),
                message: this.$t('App.notify.content_servererr'),
              })
              return
            }
          } else {
            this.$notify.error({
              title: this.$t('App.notify.title_server'),
              message: this.$t('App.notify.content_server') + response.status,
            })
            return
          }
        })
        .catch((error) => {
          this.$notify.error({
            title: this.$t('App.notify.title_server'),
            message: this.$t('App.notify.content_servererr'),
          })
          return
        })
    },
    getCountry() {
      this.$axios({
        method: 'post',
        // url: Vue.prototype.api + '6004/api/local/selectCountryForControl',
        url: Vue.prototype.api + 'api/local/selectCountryForControl',
      })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.code == '200') {
              sessionStorage.setItem(
                'listCountry',
                JSON.stringify(response.data.data)
              )
              return
            } else if (response.data.code == '210') {
              this.$notify.error({
                title: this.$t('App.notify.title_server'),
                message: this.$t('App.notify.content_entitiesept'),
              })
              return
            } else {
              this.$notify.error({
                title: this.$t('App.notify.title_server'),
                message: this.$t('App.notify.content_servererr'),
              })
              return
            }
          } else {
            this.$notify.error({
              title: this.$t('App.notify.title_server'),
              message: this.$t('App.notify.content_server') + response.status,
            })
            return
          }
        })
        .catch((error) => {
          this.$notify.error({
            title: this.$t('App.notify.title_server'),
            message: this.$t('App.notify.content_servererr'),
          })
          return
        })
    },
    getCurrency() {
      this.$request
        // .post('6004/api/local/queryCurrencyForControl')
        .post('api/local/queryCurrencyForControl')
        .then((response = {}) => {
          if (response.code == '200') {
            sessionStorage.setItem(
              'listCurrency',
              JSON.stringify(response.data)
            )
            return
          } else if (response.code == '210') {
            this.$notify.error({
              title: this.$t('App.notify.title_server'),
              message: this.$t('App.notify.content_entitiesept'),
            })
            return
          } else {
            this.$notify.error({
              title: this.$t('App.notify.title_server'),
              message: this.$t('App.notify.content_servererr'),
            })
            return
          }
        })
        .catch(() => {
          this.$notify.error({
            title: this.$t('App.notify.title_server'),
            message: this.$t('App.notify.content_servererr'),
          })
          return
        })
    },
    custLogout() {
      sessionStorage.clear()
      this.router.push({ path: '/login' })
    },
    openTabOnAva(router) {
      if (this.tabs.editableTabs.length > 0) {
        let currentTab = this.tabs.editableTabs.filter(
          (tab) => tab.router == router
        )
        if (currentTab.length > 0) {
          this.tabs.activeTab = currentTab[0].name
          return
        }
      }

      let labeltmp = router.split('/')[2]
      let titleName = 'App.tabs.' + labeltmp
      let newTabName = ++this.tabs.tabIndex + ''
      this.tabs.editableTabs.push({
        title: this.$t(titleName),
        name: newTabName,
        router: router,
      })
      this.tabs.activeTab = newTabName
      this.$router.push({ path: router })
    },
    openTabOnMenu(index, indexPath) {
      if (this.tabs.editableTabs.length > 0) {
        let currentTab = this.tabs.editableTabs.filter(
          (tab) => tab.router == index
        )
        if (currentTab.length > 0) {
          this.tabs.activeTab = currentTab[0].name
          return
        }
      }

      let labeltmp = index.split('/')[2]
      let titleName = 'App.tabs.' + labeltmp
      let newTabName = ++this.tabs.tabIndex + ''
      this.tabs.editableTabs.push({
        title: this.$t(titleName),
        name: newTabName,
        router: index,
      })
      this.tabs.activeTab = newTabName
    },
    removeTab(targetName) {
      let tabs = this.tabs.editableTabs
      let activeName = this.tabs.activeTab
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
            }
          }
        })
      }

      this.tabs.activeTab = activeName
      this.tabs.editableTabs = tabs.filter((tab) => tab.name !== targetName)
      if (this.tabs.editableTabs.length > 0) {
        let currentTab = this.tabs.editableTabs.filter(
          (tab) => tab.name === activeName
        )
        let currentRouter = currentTab[0].router
        this.$router.push({ path: currentRouter })
      } else {
        this.$router.push({ path: '/console/' })
      }
    },
    clickTab(tab) {
      if (this.tabs.editableTabs.length > 0) {
        let currentTab = this.tabs.editableTabs.filter(
          (_tab) => _tab.name == tab.name
        )
        this.$router.push({ path: currentTab[0].router })
      }
    },
  },
}
</script>

<style scoped>
a {
  text-decoration: none;
  color: white;
}

.router-link-active {
  text-decoration: none;
  color: white;
}

.main_wrap {
  overflow: hidden;
  width: 100%;
  height: 100vh;
}

.head_bar {
  width: 100%;
  height: 3.5rem;
  /* 545c64 */
  background-color: #323233;
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 999;
}

.bar_title {
  color: #fff;
  vertical-align: middle;
  font-size: 1.4rem;
  margin-left: 3rem;
  user-select: none;
}

.bar_items {
  font-size: 0.9rem;
  position: absolute;
  right: 2rem;
  user-select: none;
}

.bar_items div {
  display: table-cell;
  vertical-align: middle;
  padding-left: 0.3rem;
}

.avatar_dropdown_items_content a {
  text-decoration: none;
  color: #606266;
}

.body_wrap {
  margin-top: 3.5rem;
  width: 100%;
}

.menu_main_wrap {
  float: left;
  /* width: 120rem;
  display: flex; */
  /* overflow-y: auto; */
}

.contents {
  overflow: hidden;
  /* display: table-cell; */
  /* position:absolute */
}

::-webkit-scrollbar {
  width: 0;
  height: 0.2rem;
}

.mainmenu_content {
  text-align: left;
  width: 15rem;
  height: calc(100vh - 3.5rem);
  user-select: none;
  overflow-y: scroll;
}

.no_router_content {
  margin: 0 auto;
  padding: 40vh;
}

.smile_img {
  width: 11rem;
  margin: 0 auto;
}

.top_explain {
  font-size: 1.2rem;
  color: #878787;
  margin: 0 auto;
}

/deep/ .el-tabs__header .is-top {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/views/management/Console.vue